module.exports = __webpack_public_path__ + "static/img/search_bg.5f49d10f.jpg";